<div *ngIf="peerConnection">
  <div id="peer-connection-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.name">{{peerConnection.name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Administrative State:</span>
      <span class="map-summary-item-value" [title]="generateAdministrativeStateLabel()">{{generateAdministrativeStateLabel()}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative State:</span>
      <span class="map-summary-item-value" [title]="peerConnection.operState">{{peerConnection.operState}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">IPGroup Name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.nativeName">{{peerConnection.nativeName}}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="peerConnection.peerConnectionNodeType === 'Virtual'">
      <span class="map-summary-item-field">TGRP:</span>
      <span class="map-summary-item-value">{{peerConnection.tgrp}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Quality:</span>
      <span class="map-summary-item-value" [title]="peerConnection.result">{{peerConnection.result}}</span>
    </div>

    <div *ngIf="peerConnection.cacProfileId">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">CAC Profile:</span>
        <span class="map-summary-item-value" [title]="peerConnection.cacProfileName">{{peerConnection.cacProfileName}}</span>
      </div>
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">CAC State:</span>
        <span class="map-summary-item-value" [title]="peerConnection.cacState">{{peerConnection.cacState}}</span>
      </div>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Weight:</span>
      <span class="map-summary-item-value" [title]="peerConnection.weight">{{peerConnection.weight}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Node name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.nodeName">{{peerConnection.nodeName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Peer connection type:</span>
      <span class="map-summary-item-value" [title]="peerConnection.peerConnectionNodeType">{{peerConnection.peerConnectionNodeType}}</span>
    </div>
  </div>
</div>
